import { createFileRoute } from "@tanstack/react-router";
import Post from "@/components/StandalonePost";
import { LinkBuilder } from "@/services/link-builder";
import { isDefined } from "@/utils/is-defined";
import { siteAuthor } from "@/config/seo";
export const Route = createFileRoute("/post/$slug")({
  component: RouteComponent,
  shouldReload() {
    return false;
  },
  async loader(ctx) {
    const load = () => Promise.resolve();
    const post = await load();
    return {
      post
    };
  },
  head(ctx) {
    const post = ctx.loaderData?.post;
    if (!post) return {};
    const {
      title,
      excerpt: desc,
      thumbnail: thumb
    } = post;
    const url = LinkBuilder.build({
      route: "post",
      slug: post.slug,
      isAbsolute: true
    });
    const jsonLd: WithContext<BlogPosting> = {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      "@id": url,
      headline: title,
      image: thumb?.url,
      datePublished: post.date,
      description: post.excerpt,
      author: {
        "@type": "Person",
        name: siteAuthor
      }
    };
    return {
      scripts: [{
        type: "application/ld+json",
        children: JSON.stringify(jsonLd)
      }],
      meta: [{
        title
      }, {
        name: "description",
        content: desc
      }, {
        name: "og:title",
        content: title
      }, {
        name: "og:description",
        content: desc
      }, {
        name: "og:url",
        content: url
      }, {
        name: "og:type",
        content: "article"
      }, {
        name: "article:published_time",
        content: post.date
      }, ...(thumb ? [{
        name: "og:image",
        content: thumb.url
      }, thumb.width ? {
        name: "og:image:width",
        content: String(thumb.width)
      } : undefined, thumb.height ? {
        name: "og:image:height",
        content: String(thumb.height)
      } : undefined].filter(isDefined) : []), ...post.tags.map(tag => ({
        name: "article:tag",
        content: tag.name
      }))]
    };
  }
});
function RouteComponent() {
  const {
    slug
  } = Route.useParams();
  return <Post slug={slug} />;
}